<script>
import moment from 'moment'
import { mapState, mapGetters } from 'vuex'
import u from '@/utils'
import CredentialDetail from '@/components/identity/CredentialDetail'
import EditableListView from '@/components/common/EditableListView'
import { botApi, identitiesApi } from '../../api'

export default {
  props: {
    identityProp: Object
  },

  data() {
    return {
      editName: false,
      editDescription: false,
      editIdentityType: false,
      identityUpdating: false,
      identifiedBotsUpdating: false,
      name: '',
      description: '',
      identityType: '',
      searchAttributes: ['name', 'description', 'hexId'],
      identity: null,
      identifiedBots: [],
      bots: []
    }
  },

  computed: {
    ...mapState({
      identityTypes: state => state.enums.identityTypes,
      identityStructure: state => state.identities.identityStructure
      // identifiedBots: state => state.identities.identifiedBots,
      // bots: state => state.bots.bots
    }),
    ...mapGetters({
      can: 'can'
    }),
    credentials() {
      let selectedIdentityStructure = this.identityStructure.find(element => {
        return element.key === this.identity.identityType.key
      })
      if (selectedIdentityStructure) {
        return u.clone(selectedIdentityStructure.options).map(option => {
          option.value = this.identity.credential[
            selectedIdentityStructure.fieldName
          ][option.fieldName]
          if (option.secure) {
            option.secureVisible = false
          }
          return option
        })
      } else {
        return []
      }
    }
  },

  watch: {
    identityProp() {
      this.identity = this.identityProp
    },
    identity() {
      this.getAssociations()
      this.name = this.identity.name
      this.description = this.identity.description
      this.identityType = this.identity.identityType
    }
  },

  async created() {
    if (this.identity || this.identityProp) {
      if (!this.identity) this.identity = this.identityProp
      this.getAssociations()
    } else {
      const { data } = await identitiesApi.fetchIdentitie(
        this.$route.params.hexId
      )
      if (data) {
        this.identity = data
      }
    }
    this.getIdentityStructure()
  },

  methods: {
    getAssociations() {
      this.getIdentifiedBots()
    },

    async getIdentifiedBots() {
      this.identifiedBotsUpdating = true
      try {
        // await this.$store.dispatch('fetchIdentifiedBots', this.identity)
        this.identifiedBots = await identitiesApi.fetchIdentifiedBots(
          this.identity
        )
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Bots for Identity',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.identifiedBotsUpdating = false
    },

    async getIdentityStructure() {
      this.identityUpdating = true
      try {
        await this.$store.dispatch('fetchIdentityStructure')
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Identity Structure',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.identityUpdating = false
    },

    async setName() {
      this.identityUpdating = true
      this.editName = false
      try {
        await this.$store.dispatch('updateIdentity', {
          body: { name: this.name },
          hexId: this.identity.hexId
        })
        await this.$store.dispatch('directNotification', {
          message: 'Identity renamed Successfully',
          description: 'Identity renamed Successfully',
          type: 'success',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Identity rename Failed',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
        this.resetName()
      }
      this.identityUpdating = false
    },

    resetName() {
      this.editName = false
      this.name = this.identity.name
    },

    async setDescription() {
      this.identityUpdating = true
      this.editDescription = false
      try {
        await this.$store.dispatch('updateIdentity', {
          body: { description: this.description },
          hexId: this.identity.hexId
        })
        await this.$store.dispatch('directNotification', {
          message: 'Identity description changed Successfully',
          description: 'Identity description changed Successfully',
          type: 'success',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Identity description change Failed',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
        this.resetDescription()
      }
      this.identityUpdating = false
    },

    resetDescription() {
      this.editDescription = false
      this.description = this.identity.description
    },

    async setIdentityType() {
      this.identityUpdating = true
      this.editIdentityType = false
      try {
        await this.$store.dispatch('updateIdentityCredential', {
          body: {},
          hexId: this.identity.hexId,
          identityType: this.identityType.key
        })
        await this.$store.dispatch('directNotification', {
          message: 'Identity type updated Successfully',
          description: 'Identity type updated Successfully',
          type: 'success',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Identity type update Failed',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
        this.resetIdentityType()
      }
      this.identityUpdating = false
    },

    resetIdentityType() {
      this.editIdentityType = false
      this.identityType = this.identity.identityType
    },

    async botsAdded(bots) {
      this.identifiedBotsUpdating = true
      try {
        // await this.$store.dispatch('addBotToIdentity', {
        //   bots,
        //   identity: this.identity
        // })
        await Promise.all(
          bots.map(bot => identitiesApi.addBotToIdentity(bot, this.identity))
        )
        await this.$store.dispatch('directNotification', {
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: 'Bot has been assigned to Identity Successfully',
          message: 'Bot has been assigned to Identity Successfully',
          type: 'success'
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          message: 'Unable to assign Bot(s) to Identity',
          type: 'error'
        })
      }
      try {
        // await this.$store.dispatch('fetchIdentifiedBots', this.identity)
        this.identifiedBots = await identitiesApi.fetchIdentifiedBots(
          this.identity
        )
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Bot(s) for Identity',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.identifiedBotsUpdating = false
    },

    async botsDeleted(bots) {
      this.identifiedBotsUpdating = true
      try {
        // await this.$store.dispatch('deleteBotFromIdentity', {
        //   bots,
        //   identity: this.identity
        // })
        await Promise.all(
          bots.map(bot =>
            identitiesApi.deleteBotFromIdentity(bot, this.identity)
          )
        )
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'Bot(s) deleted for Identity Successfully',
          description: 'Bot(s) deleted for Identity Successfully',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to delete Bot(s)',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      try {
        // await this.$store.dispatch('fetchIdentifiedBots', this.identity)
        this.identifiedBots = await identitiesApi.fetchIdentifiedBots(
          this.identity
        )
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Bot(s) for Identity',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.identifiedBotsUpdating = false
    },

    async credentialUpdated(body) {
      this.identityUpdating = true
      try {
        await this.$store.dispatch('updateIdentityCredential', {
          body,
          hexId: this.identity.hexId,
          identityType: this.identityType.key
        })
        await this.$store.dispatch('directNotification', {
          message: 'Identity value updated Successfully',
          description: 'Identity value updated Successfully',
          type: 'success',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Identity value update Failed',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.identityUpdating = false
    },

    async search(query) {
      try {
        this.identifiedBotsUpdating = true
        const { data } = await botApi.fetchBots(
          query && `?search=${query}&page=1&size=20`
        )
        this.bots = data._embedded.bots
        this.identifiedBotsUpdating = false
      } catch (error) {
        console.log(error)
      }
    }
  },

  components: {
    CredentialDetail,
    EditableListView
  }
}
</script>

<template>
  <v-card class="beez-card">
    <v-toolbar dense card class="elevation-2">
      <v-toolbar-title class="body-2 beez-bold "
        >{{ identity.name }}
      </v-toolbar-title>
    </v-toolbar>
    <v-progress-linear
      indeterminate
      color="accent"
      class="ma-0"
      height="5"
      :active="identityUpdating"
    />
    <div class="pa-3">
      <v-text-field
        color="secondary"
        :outline="$vuetify.dark"
        label="Name"
        v-model="name"
        :readonly="!editName"
      >
        <template slot="append">
          <template v-if="editName">
            <v-icon @click="resetName">clear</v-icon>
            <v-icon @click="setName">save</v-icon>
          </template>
          <template v-else>
            <v-icon v-if="can('IDENTITIES_NAME_EDIT')" @click="editName = true"
              >edit
            </v-icon>
          </template>
        </template>
      </v-text-field>

      <v-textarea
        label="Description"
        v-model="description"
        :readonly="!editDescription"
        :rows="1"
        auto-grow
        :outline="$vuetify.dark"
        color="secondary"
      >
        <template slot="append">
          <template v-if="editDescription">
            <v-icon @click="resetDescription">clear</v-icon>
            <v-icon @click="setDescription">save</v-icon>
          </template>
          <template v-else>
            <v-icon
              v-if="can('IDENTITIES_DES_EDIT')"
              @click="editDescription = true"
              >edit
            </v-icon>
          </template>
        </template>
      </v-textarea>
      <!-- Todo: Fix the Identity Changing Screen Upon Editing -->
      <v-select
        color="secondary"
        :outline="$vuetify.dark"
        :items="identityTypes"
        item-text="friendlyName"
        item-value="key"
        v-model="identityType"
        label="Identity Type"
        two-line
        return-object
        :readonly="!editIdentityType"
      >
        <template slot="append-outer">
          <template v-if="editIdentityType">
            <v-icon @click="resetIdentityType">clear</v-icon>
            <v-icon @click="setIdentityType">save</v-icon>
          </template>
          <template v-else>
            <v-icon
              v-if="can('IDENTITIES_TYPE_EDIT')"
              @click="editIdentityType = true"
              >edit
            </v-icon>
          </template>
        </template>
      </v-select>

      <credential-detail
        :value="credentials"
        updatable
        @save="credentialUpdated"
      />

      <editable-list-view
        v-if="can('IDENTITIES_BOTS_DISPLAY')"
        title="Bots"
        :selectedItems="identifiedBots"
        :allItems="bots"
        :updating="identifiedBotsUpdating"
        :key="'pro-' + identity.hexId"
        @added="botsAdded"
        @deleted="botsDeleted"
        :search-attributes="searchAttributes"
        @queryChanged="query => search(query)"
      >
        <template slot="empty-list-placeholder-selected">
          Please click the edit icon to start adding Bots.
        </template>

        <template
          :slot="slotName"
          v-for="(slotName, i) in [
            'list-item-selected',
            'list-item-add',
            'list-item-delete'
          ]"
          slot-scope="props"
        >
          <v-hover>
            <v-list-tile-content slot-scope="{ hover }">
              <v-container fulid>
                <v-layout row>
                  <v-flex shrink>
                    <v-avatar size="50">
                      <img src="/images/Bot.svg" alt="link" />
                    </v-avatar>
                  </v-flex>
                  <v-flex grow pl-4>
                    <v-list-tile-title>{{ props.item.name }}</v-list-tile-title>
                    <v-list-tile-sub-title
                      >{{ props.item.description }}
                    </v-list-tile-sub-title>
                  </v-flex>
                  <v-flex shrink>
                    <v-tooltip bottom>
                      <v-btn
                        v-if="hover"
                        slot="activator"
                        icon
                        flat
                        small
                        :to="{
                          name: 'bot-detail',
                          params: { hexId: props.item.hexId }
                        }"
                      >
                        <v-icon>link</v-icon>
                      </v-btn>
                      <span>Quick Link</span>
                    </v-tooltip>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-list-tile-content>
          </v-hover>
        </template>
      </editable-list-view>
    </div>
  </v-card>
</template>

<style scoped>
.one:hover {
  background: rgba(0, 0, 0, 0);

  box-shadow: 0px 0px 0px transparent;

  border: 0px solid transparent;

  text-shadow: 0px 0px 0px transparent;
}
</style>
